exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-db3ad9a0] {\n  border-color: red;\n}", ""]);

// exports
